/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* react-slick carousel based out of 0.28.1 (@accedo/vdkweb-react-slick) 4.1.8
* 
*******************************************************************************/
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/sort-comp */
/* eslint-disable consistent-return */

'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["animating"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import classnames from 'classnames';
import ResizeObserver from 'resize-observer-polyfill';
import initialState from './initial-state';
import { getOnDemandLazySlides, extractObject, initializedState, getHeight, canGoNext, slideHandler, changeSlide, keyHandler, swipeStart, swipeMove, swipeEnd, getPreClones, getPostClones, getTrackLeft, getTrackCSS } from './utils/innerSliderUtils';
import { Track } from './track';
import { Dots } from './dots';
import { PrevArrow, NextArrow } from './arrows';

// eslint-disable-next-line valid-jsdoc
/**
 * The inner-slider component is used by Slider component internally.
 *
 * To use the react-slick, please see the [Slider documentation](/#slider).
 * * The props for this component must be passed through slider one.
 *
 * @returns {node} The inner-slider component
 */
var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);
  var _super = _createSuper(InnerSlider);
  function InnerSlider(props) {
    var _this;
    _classCallCheck(this, InnerSlider);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      _this.list = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      _this.track = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
        _this.list.style.height = "".concat(getHeight(elem), "px");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) {
        _this.debouncedResize.cancel();
      }
      _this.debouncedResize = debounce(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    });
    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node);
      // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) {
        return;
      }
      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) {
          _this.autoPlay('update');
        } else {
          _this.pause('paused');
        }
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });
    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = initializedState(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = getTrackLeft(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = getTrackCSS(spec);
      if (setTrackStyle || React.Children.count(_this.props.children) !== React.Children.count(spec.children)) {
        updatedState.trackStyle = trackStyle;
      }
      _this.setState(updatedState, callback);
    });
    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0;
        var _trackLeft = 0;
        var childrenWidths = [];
        var preClones = getPreClones(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = getPostClones(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i += 1) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i = 0; _i < postClones; _i += 1) {
          _trackWidth += childrenWidths[_i];
        }
        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2 += 1) {
          _trackLeft += childrenWidths[_i2];
        }
        var _trackStyle = {
          width: "".concat(_trackWidth, "px"),
          left: "".concat(-_trackLeft, "px")
        };
        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }
        return {
          trackStyle: _trackStyle
        };
      }
      var childrenCount = React.Children.count(_this.props.children);
      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });
      var slideCount = getPreClones(spec) + getPostClones(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * (getPreClones(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: "".concat(trackWidth, "%"),
        left: "".concat(trackLeft, "%")
      };
      return {
        slideWidth: "".concat(slideWidth, "%"),
        trackStyle: trackStyle
      };
    });
    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll('.slick-slide img') || [];
      var imagesCount = images.length;
      var loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return (
            // eslint-disable-next-line no-plusplus
            ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized()
          );
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];
      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + getPostClones(spec); index += 1) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -getPreClones(spec); _index -= 1) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
        delete _this.lazyLoadTimer;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
        asNavFor = _this$props.asNavFor,
        beforeChange = _this$props.beforeChange,
        onLazyLoad = _this$props.onLazyLoad,
        speed = _this$props.speed,
        afterChange = _this$props.afterChange;
      // capture currentslide before state is updated
      var currentSlide = _this.state.currentSlide;
      var _slideHandler = slideHandler(_objectSpread(_objectSpread(_objectSpread({
          index: index
        }, _this.props), _this.state), {}, {
          trackRef: _this.track,
          useCSS: _this.props.useCSS && !dontAnimate
        })),
        state = _slideHandler.state,
        nextState = _slideHandler.nextState;
      if (!state) {
        return;
      }
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }
      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }
        if (!nextState) {
          return;
        }
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
            firstBatch = _objectWithoutProperties(nextState, _excluded);
          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
      var targetSlide = changeSlide(spec, options);
      if (targetSlide !== 0 && !targetSlide) {
        return;
      }
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
      _this.props.autoplay && _this.autoPlay('update');
      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll('.slick-current');
        nodes[0] && nodes[0].focus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    });
    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = keyHandler(e, _this.props.accessibility, _this.props.rtl);
      dir !== '' && _this.changeSlide({
        message: dir
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });
    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) {
          e.preventDefault();
        }
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    });
    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });
    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = swipeStart(e, _this.props.swipe, _this.props.draggable);
      state !== '' && _this.setState(state);
    });
    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = swipeMove(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) {
        return;
      }
      if (state.swiping) {
        _this.clickable = false;
      }
      _this.setState(state);
    });
    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = swipeEnd(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) {
        return;
      }
      var triggerSlideHandler = state.triggerSlideHandler;
      delete state.triggerSlideHandler;
      _this.setState(state);
      if (triggerSlideHandler === undefined) {
        return;
      }
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);
      _this.clickable = true;
    });
    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: 'previous'
        });
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: 'next'
        });
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (Number.isNaN(Number(slide))) {
        return '';
      }
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: 'index',
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });
    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else if (canGoNext(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
        nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
      } else {
        return false;
      }
      _this.slideHandler(nextIndex);
    });
    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === 'update') {
        if (autoplaying === 'hovered' || autoplaying === 'focused' || autoplaying === 'paused') {
          return;
        }
      } else if (playType === 'leave') {
        if (autoplaying === 'paused' || autoplaying === 'focused') {
          return;
        }
      } else if (playType === 'blur') {
        if (autoplaying === 'paused' || autoplaying === 'hovered') {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({
        autoplaying: 'playing'
      });
    });
    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === 'paused') {
        _this.setState({
          autoplaying: 'paused'
        });
      } else if (pauseType === 'focused') {
        if (autoplaying === 'hovered' || autoplaying === 'playing') {
          _this.setState({
            autoplaying: 'focused'
          });
        }
      } else if (autoplaying === 'playing') {
        // pauseType  is 'hovered'
        _this.setState({
          autoplaying: 'hovered'
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause('hovered');
    });
    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === 'hovered' && _this.autoPlay('leave');
    });
    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause('hovered');
    });
    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === 'hovered' && _this.autoPlay('leave');
    });
    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause('focused');
    });
    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === 'focused' && _this.autoPlay('blur');
    });
    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, initialState), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: React.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    var ssrState = _this.ssrInit();
    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }
  _createClass(InnerSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.props.onInit && this.props.onInit();
      if (this.props.lazyLoad) {
        var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, this.props), this.state));
        if (slidesToLoad.length > 0) {
          this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (this.props.onLazyLoad) {
            this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      var spec = _objectSpread({
        listRef: this.list,
        trackRef: this.track
      }, this.props);
      this.updateState(spec, true, function () {
        _this2.adaptHeight();
        _this2.props.autoplay && _this2.autoPlay('update');
      });
      if (this.props.lazyLoad === 'progressive') {
        this.lazyLoadTimer = setInterval(this.progressiveLazyLoad, 1000);
      }
      this.ro = new ResizeObserver(function () {
        if (_this2.state.animating) {
          _this2.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this2.callbackTimers.push(setTimeout(function () {
            return _this2.onWindowResized();
          }, _this2.props.speed));
        } else {
          _this2.onWindowResized();
        }
      });
      if (this.list) {
        this.ro.observe(this.list);
      }
      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll('.slick-slide'), function (slide) {
        slide.onfocus = _this2.props.pauseOnFocus ? _this2.onSlideFocus : null;
        slide.onblur = _this2.props.pauseOnFocus ? _this2.onSlideBlur : null;
      });
      if (window.addEventListener) {
        window.addEventListener('resize', this.onWindowResized);
      } else {
        window.attachEvent('onresize', this.onWindowResized);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.animationEndCallback) {
        clearTimeout(this.animationEndCallback);
      }
      if (this.lazyLoadTimer) {
        clearInterval(this.lazyLoadTimer);
      }
      if (this.callbackTimers.length) {
        this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener('resize', this.onWindowResized);
      } else {
        window.detachEvent('onresize', this.onWindowResized);
      }
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
      }
      this.ro.disconnect();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      this.checkImagesLoad();
      this.props.onReInit && this.props.onReInit();
      if (this.props.lazyLoad) {
        var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, this.props), this.state));
        if (slidesToLoad.length > 0) {
          this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (this.props.onLazyLoad) {
            this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      this.adaptHeight();
      var spec = _objectSpread(_objectSpread({
        listRef: this.list,
        trackRef: this.track
      }, this.props), this.state);
      var setTrackStyle = this.didPropsChange(prevProps);
      setTrackStyle && this.updateState(spec, setTrackStyle, function () {
        if (_this3.state.currentSlide >= React.Children.count(_this3.props.children)) {
          _this3.changeSlide({
            message: 'index',
            index: React.Children.count(_this3.props.children) - _this3.props.slidesToShow,
            currentSlide: _this3.state.currentSlide
          });
        }
        if (_this3.props.autoplay) {
          _this3.autoPlay('update');
        } else {
          _this3.pause('paused');
        }
      });
    }
  }, {
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var _this4 = this;
      Object.keys(this.props).forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(prevProps, key)) {
          return true;
        }
        if (prevProps[key] !== _this4.props[key]) {
          return true;
        }
      });
      return React.Children.count(this.props.children) !== React.Children.count(prevProps.children);
    }
  }, {
    key: "render",
    value: function render() {
      var className = classnames('slick-slider', this.props.className, {
        'slick-vertical': this.props.vertical,
        'slick-initialized': true
      });
      var spec = _objectSpread(_objectSpread({}, this.props), this.state);
      var trackProps = extractObject(spec, ['fade', 'cssEase', 'speed', 'infinite', 'centerMode', 'focusOnSelect', 'currentSlide', 'lazyLoad', 'lazyLoadedList', 'rtl', 'slideWidth', 'slideHeight', 'listHeight', 'vertical', 'slidesToShow', 'slidesToScroll', 'slideCount', 'trackStyle', 'variableWidth', 'unslick', 'centerPadding', 'targetSlide', 'useCSS']);
      var pauseOnHover = this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? this.onTrackOver : null,
        focusOnSelect: this.props.focusOnSelect && this.clickable ? this.selectHandler : null
      });
      var dots;
      if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
        var dotProps = extractObject(spec, ['dotsClass', 'slideCount', 'slidesToShow', 'currentSlide', 'slidesToScroll', 'clickHandler', 'children', 'customPaging', 'infinite', 'appendDots']);
        var pauseOnDotsHover = this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? this.onDotsLeave : null
        });
        dots = /*#__PURE__*/React.createElement(Dots, dotProps);
      }
      var prevArrow;
      var nextArrow;
      var arrowProps = extractObject(spec, ['infinite', 'centerMode', 'currentSlide', 'slideCount', 'slidesToShow', 'prevArrow', 'nextArrow']);
      arrowProps.clickHandler = this.changeSlide;
      if (this.props.arrows) {
        prevArrow = /*#__PURE__*/React.createElement(PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/React.createElement(NextArrow, arrowProps);
      }
      var verticalHeightStyle = null;
      if (this.props.vertical) {
        verticalHeightStyle = {
          height: this.state.listHeight
        };
      }
      var centerPaddingStyle = null;
      if (this.props.vertical === false) {
        if (this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "".concat(this.props.centerPadding || 0, "px")
          };
        }
      } else if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: "".concat(this.props.centerPadding || 0, "px")
        };
      }
      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
      var touchMove = this.props.touchMove;
      var listProps = {
        className: 'slick-list',
        style: listStyle,
        onClick: this.clickHandler,
        onMouseDown: touchMove ? this.swipeStart : null,
        onMouseMove: this.state.dragging && touchMove ? this.swipeMove : null,
        onMouseUp: touchMove ? this.swipeEnd : null,
        onMouseLeave: this.state.dragging && touchMove ? this.swipeEnd : null,
        onTouchStart: touchMove ? this.swipeStart : null,
        onTouchMove: this.state.dragging && touchMove ? this.swipeMove : null,
        onTouchEnd: touchMove ? this.touchEnd : null,
        onTouchCancel: this.state.dragging && touchMove ? this.swipeEnd : null,
        onKeyDown: this.props.accessibility ? this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        style: this.props.style
      };
      if (this.props.unslick) {
        listProps = {
          className: 'slick-list'
        };
        innerSliderProps = {
          className: className
        };
      }
      return /*#__PURE__*/React.createElement("div", innerSliderProps, !this.props.unslick ? prevArrow : '', /*#__PURE__*/React.createElement("div", _extends({
        ref: this.listRefHandler
      }, listProps), /*#__PURE__*/React.createElement(Track, _extends({
        ref: this.trackRefHandler
      }, trackProps), this.props.children)), !this.props.unslick ? nextArrow : '', !this.props.unslick ? dots : '');
    }
  }]);
  return InnerSlider;
}(React.Component);
InnerSlider.defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/React.createElement("ul", {
      style: {
        display: 'block'
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: '50',
  className: '',
  currentSlide: 0,
  customPaging: function customPaging(i) {
    return /*#__PURE__*/React.createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: 'slick-dots',
  draggable: true,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: 'div',
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeToSlide: false,
  touchMove: true,
  useCSS: true,
  variableWidth: false,
  vertical: false,
  verticalSwiping: false,
  waitForAnimate: true
};
InnerSlider.propTypes = {
  /** Enables tabbing and arrow key navigation */
  accessibility: PropTypes.bool,
  /** Adjust the slide's height automatically */
  adaptiveHeight: PropTypes.bool,
  /** Function to be executed after each scroll */
  afterChange: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /** Custom dots templates. Works same as customPaging */
  appendDots: PropTypes.func,
  /** True whether it must show left and right nav arrows */
  arrows: PropTypes.bool,
  /** Nav object */
  asNavFor: PropTypes.object,
  /** True whether the scroller auto scroll */
  autoplay: PropTypes.bool,
  /** Delay between each auto scoll in ms */
  autoplaySpeed: PropTypes.number,
  /** Index change callback. `(oldIndex, newIndex) => ...` */
  beforeChange: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /** True whether it centers to a single item */
  centerMode: PropTypes.bool,
  /** Padding for the center item */
  centerPadding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** The items of the carousel */
  children: PropTypes.array,
  /** Additional class name for the inner slider div */
  className: PropTypes.string,
  /** The starting slide */
  currentSlide: PropTypes.number,
  /** Custom paging templates. [Example](examples/CustomPaging.js) */
  customPaging: PropTypes.func,
  /** True whether it must show navigation dots */
  dots: PropTypes.bool,
  /** CSS class for navigation dots  */
  dotsClass: PropTypes.string,
  /** True whether it can be scroll by dragging the items */
  draggable: PropTypes.bool,
  /** True whether it has to focus on selection */
  focusOnSelect: PropTypes.bool,
  /**  Infinitely wrap around contents */
  infinite: PropTypes.bool,
  /** What item should be the first to be displayed */
  initialSlide: PropTypes.number,
  /** True wheather it loads images or renders components on demands */
  lazyLoad: PropTypes.bool,
  /** Function callback to be executed once the slick is rendered */
  onInit: PropTypes.func,
  /** Function callback to be executed after each lazy load */
  onLazyLoad: PropTypes.func,
  /** Function callback to be executed after each lazy load error */
  onLazyLoadError: PropTypes.func,
  /** Function callback to be executed after update the slick */
  onReInit: PropTypes.func,
  /** True to stop the autoplay on dots hover */
  pauseOnDotsHover: PropTypes.bool,
  /** True to stop the autoplay on focus */
  pauseOnFocus: PropTypes.bool,
  /** True to stop the autoplay on hover */
  pauseOnHover: PropTypes.bool,
  /** Customize based on breakpoints (see the demo example for better understanding) */
  responsive: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Number of rows per slide in the slider, (enables grid mode) */
  rows: PropTypes.number,
  /** True to render itemas from right to left */
  rtl: PropTypes.bool,
  /** Slide container type */
  slide: PropTypes.string,
  /** Number of slides to display in grid mode, this is useful with rows option */
  slidesPerRow: PropTypes.number,
  /** Number of items scrolled by each time */
  slidesToScroll: PropTypes.number,
  /** How many slides to show in one frame */
  slidesToShow: PropTypes.number,
  /** Navigation speed */
  speed: PropTypes.number,
  /** Style object */
  style: PropTypes.object,
  /** Enable/disable swiping to change slides */
  swipe: PropTypes.bool,
  /** Enable drag/swipe irrespective of `slidesToScroll` */
  swipeToSlide: PropTypes.bool,
  /** Enable/disable move on touch */
  touchMove: PropTypes.bool,
  /**  @ignore */
  unslick: PropTypes.bool,
  /** Enable/Disable CSS Transitions */
  useCSS: PropTypes.bool,
  /** True if the items have different width */
  variableWidth: PropTypes.bool,
  /** True if the slick has to move vertically */
  vertical: PropTypes.bool,
  /** Enable/disable swiping to change slides */
  verticalSwiping: PropTypes.bool,
  /** True to wait until the animation is finish to execute callbacks */
  waitForAnimate: PropTypes.bool
};
export { InnerSlider };